<template>
	<footer class="footer hidden-print classroomView">
		<div class="container base-footer">
			<div class="row">
				<div class="col-sm-12 col-md-3">
					<div class="card card-dark">
						<div class="card-heading">
							<h2 class="card-title">Följ spsm</h2>
						</div>
						<div class="card-social">
							<a href="https://www.facebook.com/SPSMsverige">
								<span class="fa-stack">
									<span class="fab fa-facebook-f"></span>
								</span>
								<span class="sr-only">
									SPSM på Facebook
								</span>
							</a>
							<a href="https://twitter.com/SPSMsverige">
								<span class="fa-stack">
									<span class="fab fa-twitter"></span>
								</span>
								<span class="sr-only">
									SPSM på Twitter
								</span>
							</a>
							<a href="https://www.youtube.com/channel/UCsPJh8zBA5iyhcxMBMMwfUw">
								<span class="fa-stack">
									<span class="fab fa-youtube"></span>
								</span>
								<span class="sr-only">
									SPSM på YouTube
								</span>
							</a>
							<a href="https://www.spsm.se/kurser--aktiviteter/nyheter/nyheter-rss/">
								<span class="fa-stack">
									<span class="fa fa-rss"></span>
								</span>
								<span class="sr-only">
									RSS
								</span>
							</a>
						</div>
					</div>
				</div>
				<div class="col-sm-12 col-md-6">
					<div class="card card-dark">
						<div class="card-heading">
							<h2 class="card-title">Kontakta oss</h2>
						</div>
						<div class="row">
							<div class="col-sm-6">
								<p>Telefon: 010 473 50 00</p>
							</div>
							<div class="col-sm-6">
								<p>E-post: <a href="mailto:spsm@spsm.se">spsm@spsm.se</a></p>
							</div>
						</div>
					</div>
				</div>
				<div class="col-sm-12 col-md-3">
					<img src="https://www.spsm.se/imagevault/publishedmedia/8lqchinykoxmztkphexb/SPSM_white.svg"
						alt="Specialpedagogiska skolmyndigheten" class="footer_logo">
				</div>
			</div>
		</div>
	</footer>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
	name: "Footer",
});

</script>

<style lang="scss">

</style>